<div class="summary-card">
  <ul class="metadata-list">
    <li class="metadata-row">
      <strong class="metadata-label"> Source </strong>
      {{ dataSource$ | async }}
    </li>
    <li class="metadata-row">
      <strong class="metadata-label"> Records </strong>
      <div class="metadata-content">
        {{ rowCount | number }}
      </div>
    </li>
    <li class="metadata-row">
      <strong class="metadata-label"> Total columns </strong>
      <div class="space-between">
        <span data-test="column-count" class="metadata-content">
          {{ columnCount | number }}
        </span>
        <capra-status-icon
          *ngIf="hasCalcFields"
          data-test="calc-fields-warning-icon"
          class="warning-icon"
          status="warning"
          capraTooltip
          [tooltipContent]="calcFieldsWarning"
          [tooltipContentIsHtml]="true"
          tooltipPlacement="left"
        ></capra-status-icon>
      </div>
    </li>
    <li class="metadata-row">
      <strong class="metadata-label"> Size </strong>
      <div class="metadata-content">
        {{ formattedBytesSize$ | async }}
      </div>
    </li>
    <li class="metadata-row" *ngIf="!isNotebookCell">
      <strong class="metadata-label"> Connection </strong>
      <div class="metadata-content">
        {{ connection }}
      </div>
    </li>
    <li class="metadata-row">
      <strong class="metadata-label"> Collection </strong>
      <div class="metadata-content">
        {{ collection }}
      </div>
    </li>
    <li class="metadata-row">
      <strong class="metadata-label"> Schedules </strong>
      <div class="metadata-content schedules">
        <div *ngIf="schedules.length === 0" class="no-schedules">
          <span data-test="no-schedules">No {{ isSheetDataset ? 'sync' : 'run' }} schedules</span>
          <capra-status-icon
            class="warning-icon"
            status="warning"
            capraTooltip
            modeTrackClick
            [trackClickData]="{ action: 'add-schedule-click', location: 'dataset-metadata' }"
            [tooltipContent]="noScheduleWarning"
            [tooltipContentIsHtml]="true"
            tooltipPlacement="left"
            [tooltipButtonSelectors]="tooltipButtonSelectors"
            (tooltipButtonClick)="addScheduleClick.emit()"
          ></capra-status-icon>
        </div>
        <span *ngIf="schedules.length > 0" capraTooltip [tooltipContent]="schedules" tooltipPlacement="top">
          {{ schedules }}
        </span>
      </div>
    </li>
  </ul>
</div>
